import React, { useEffect, createElement } from 'react';
export default function SeccionSecretaPage() {
  // Load Typeform script on mount
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen flex items-center justify-center bg-[#0C0A09] text-[#F5EDE0] px-4 py-8" data-id="element-372">
      <div className="w-full max-w-[780px] mx-auto py-[60px] animate-fadeIn" style={{
      animation: 'fadeIn 0.7s ease-in-out'
    }} data-id="element-373">
        <div className="text-center space-y-4 mb-8" data-id="element-374">
          <h1 className="text-2xl font-semibold text-[#C89B40]" data-id="element-375">
            Acceso confirmado
          </h1>
          <p className="text-sm text-[#d9cec0]" data-id="element-376">
            Has desbloqueado el contenido exclusivo de tu compra. Completa el
            Test de Arquetipos Decisor a continuación.
          </p>
        </div>

        <div className="relative rounded-lg p-1" style={{
        background: 'linear-gradient(135deg, rgba(202, 155, 64, 0.15), rgba(202, 155, 64, 0.05))',
        boxShadow: '0 0 60px rgba(202, 155, 64, 0.3), 0 0 100px rgba(202, 155, 64, 0.15), inset 0 0 40px rgba(202, 155, 64, 0.1)'
      }} data-id="element-377">
          <div className="bg-[#0C0A09] rounded-lg overflow-hidden" style={{
          minHeight: '500px'
        }} data-id="element-378">
            <div data-tf-live="01KBRJR0PV8AXQC9B09DB4Z2FP" data-id="element-379"></div>
          </div>
        </div>
      </div>

      <style data-id="element-380">{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>;
}